function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}

module.exports = _complement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_complement.js
// module id = 1048
// module chunks = 8